<script>
export default {
  capitalizeText: function (text) {
    let splitText = text.split(' ')
    splitText.forEach((value, index) => {
      splitText[index] = value.charAt(0).toUpperCase() + value.slice(1)
    })

    return splitText.join(' ')
  },
  lowerCase: function (text) {
    return text.toLowerCase()
  },
  truncate: function (value, limit) {
    if (value.length > limit) {
      value = value.substring(0, (limit - 3)) + '...'
    }

    return value
  },
  mixUpperAndLowerCase: function (text) {
    var splitText = text.split('')

    splitText.forEach((value, index) => {
      if (index % 2 === 0) {
        splitText[index] = value.toUpperCase()
      } else {
        splitText[index] = value.toLowerCase()
      }
    })

    return splitText.join('')
  },
  getTextByLang: function (item, option, lang) {
    let textByLang = ''
    try {
      switch (option) {
        case 'title':
          if (lang === 'es') {
            textByLang = item.title_es || item.title
          } else {
            textByLang = item.title
          }
          break
        case 'content':
          if (lang === 'es') {
            textByLang = item.content_es || item.content
          } else {
            textByLang = item.content
          }
          break
        case 'description':
          if (lang === 'es') {
            textByLang = item.description_es || item.description || item.content
          } else {
            textByLang = item.description || item.content
          }
          break
        case 'category':
          if (item) {
            if (lang === 'es') {
              textByLang = (item.category) ? item.category.name_es : item.name_es
            } else {
              textByLang = (item.category) ? item.category.name : item.name
            }
          } else {
            textByLang = ''
          }
          break
      }
      if (textByLang.length > 100) {
        textByLang = window.$('<div />', {html: textByLang}).text().slice(0, 100) + '...'
      }
    } catch (error) {}
    return textByLang
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/utils/filters.vue